import React from 'react';
import DefaultProfileImage from '../../../images/ProfilePicture/HH_ProfileDefaultImage.png';
import DefaultAdminImage from '../../../images/ProfilePicture/HH_AdminDefaultImage.png';


export const startConversation = async ({ authTokens, workerId, parentId, adminId }) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/chat/conversation/start-chat/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authTokens.access}`,
      },
      body: JSON.stringify({
        workerId: workerId || null,
        parentId: parentId || null,
        adminId: adminId || null,
      }),
    });

    if (response.ok) {
      const newConversation = await response.json();
      return { success: true, data: newConversation };
    } else {
      console.error('Error al iniciar la conversación');
      return { success: false, error: response.statusText };
    }
  } catch (error) {
    console.error('Error al iniciar la conversación:', error);
    return { success: false, error };
  }
};

export const DateSeparator = ({ date }) => (
  <div className="date-separator">
    <span>{date}</span>
  </div>
);

export const formatDate = (date) => {
  const today = new Date();
  const messageDate = new Date(date);

  if (
    messageDate.getDate() === today.getDate() &&
    messageDate.getMonth() === today.getMonth() &&
    messageDate.getFullYear() === today.getFullYear()
  ) {
    return 'Hoy';
  }

  const yesterday = new Date();
  yesterday.setDate(today.getDate() - 1);

  if (
    messageDate.getDate() === yesterday.getDate() &&
    messageDate.getMonth() === yesterday.getMonth() &&
    messageDate.getFullYear() === yesterday.getFullYear()
  ) {
    return 'Ayer';
  }

  const day = messageDate.getDate().toString().padStart(2, '0');
  const month = (messageDate.getMonth() + 1).toString().padStart(2, '0');
  const year = messageDate.getFullYear();

  return `${day}/${month}/${year}`;
};

export const getConversationPartner = (conversation, currentUser) => {
  if (!conversation) {
    return { name: 'Unknown', profileImage: DefaultProfileImage, profileType: '', profileId: '' };
  }

  const workerUser = conversation.worker?.user;
  const parentUser = conversation.parent?.user;

  const isChatWithAdmin = (
    (conversation.parent === null && workerUser?.id === currentUser.id) ||
    (conversation.worker === null && parentUser?.id === currentUser.id)
  );

  if (isChatWithAdmin) {
    return {
      name: 'Happy Home',
      profileImage: DefaultAdminImage,
      profileType: 'admin',
      profileId: null,
    };
  }

  if (workerUser && workerUser.id === currentUser.id && parentUser) {
    return {
      name: parentUser.first_name,
      profileImage: parentUser.profile_image || DefaultProfileImage,
      profileType: 'parent-profile',
      profileId: parentUser.id,
    };
  }

  if (parentUser && parentUser.id === currentUser.id && workerUser) {
    return {
      name: workerUser.first_name,
      profileImage: workerUser.profile_image || DefaultProfileImage,
      profileType: 'worker-profile',
      profileId: workerUser.id,
    };
  }

  if (workerUser && workerUser.id !== currentUser.id) {
    return {
      name: workerUser.first_name,
      profileImage: workerUser.profile_image || DefaultProfileImage,
      profileType: 'worker-profile',
      profileId: workerUser.id,
    };
  }

  if (parentUser && parentUser.id !== currentUser.id) {
    return {
      name: parentUser.first_name,
      profileImage: parentUser.profile_image || DefaultProfileImage,
      profileType: 'parent-profile',
      profileId: parentUser.id,
    };
  }

  return { name: 'Unknown', profileImage: DefaultProfileImage, profileType: '', profileId: '' };
};

export const scrollToBottom = (messagesContainerRef) => {
  if (messagesContainerRef.current) {
    messagesContainerRef.current.scrollTo({
      top: messagesContainerRef.current.scrollHeight,
      behavior: 'smooth',
    });
  }
};

export const handleProfileClick = (getConversationPartner, navigate) => {
  if (getConversationPartner.profileType === 'worker-profile') {
    navigate(`/${getConversationPartner.profileType}/${getConversationPartner.profileId}/`);
  } else if (getConversationPartner.profileType === 'parent-profile') {
    navigate(`/${getConversationPartner.profileType}/${getConversationPartner.profileId}/`);
  }
};

export const formatTimeForLastMessage = (timestamp) => {
  const date = new Date(timestamp);
  const now = new Date();

  const isToday = date.toDateString() === now.toDateString();

  const yesterday = new Date();
  yesterday.setDate(now.getDate() - 1);
  const isYesterday = date.toDateString() === yesterday.toDateString();

  if (isToday) {
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  } else if (isYesterday) {
    return 'Yesterday';
  } else {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
};

export const getConversationLastMessage = (conversation) => {
  const messages = conversation.messages;
  if (messages && messages.length > 0) {
    const lastMessage = messages[messages.length - 1].content;
    return lastMessage.length > 10 ? lastMessage.substring(0, 15) + "..." : lastMessage;
  }
  return 'Sin mensajes';
};